module.exports = __webpack_public_path__ + "da74bdd683d8160d985ea32c02c402ee.png";